import { render, staticRenderFns } from "./NnnFooter.vue?vue&type=template&id=aefd6450&scoped=true&"
import script from "./NnnFooter.vue?vue&type=script&lang=ts&"
export * from "./NnnFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NnnFooter.vue?vue&type=style&index=0&id=aefd6450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefd6450",
  null
  
)

export default component.exports